// src/pages/UploadPage.jsx
import React from "react";
import UploadForm from "../components/UploadForm";

export default function UploadPage() {
  return (
        
        <UploadForm />

  );
}


